import { gql } from '@apollo/client';

import {
  TXN_FIELDS,
  TXN_LINE_FIELDS,
} from 'app/src/components/Accounting/Txns/queries';

export const ASSET_EXPENSES = gql`
  ${TXN_FIELDS}
  ${TXN_LINE_FIELDS}
  query AssetExpenses ($id: ID!) {
    asset (id: $id) {
      txnLines(scopes: ["expense_txn"]) {
        ...TxnLineFields
        txn {
          ...TxnFields
          txnLines {
            ...TxnLineFields
          }
        }
      }
    }
  }
`;
